export default __webpack_public_path__ + "static/media/mission.23e02bed.png";